export enum AutocompleteModalId {
  ADDRESS = 'ADDRESS',
  NEW_SAVED_PLACED = 'NEW_SAVED_PLACED',
  ALL_SAVED_PLACED = 'ALL_SAVED_PLACED',
  PIN_ON_MAP = 'PIN_ON_MAP',
}
